import Container from "@/components/common/Container";
import Image from "next/image";
import Title from "./common/Title";
import TestiMonialsDoubleQuotes from "./svg/TestimonialsDoubleQuotes";

const Testimonials = () => (
  <Container className="bg-black-pearl py-20 xl:py-36">
    <Title customClass="pb-10 md:pb-20 xl:pb-24" SubTitle="Client’s Words" />
    <Container large>
      <div className="xl:px-72">
        <span className="pb-4 md:pb-0">
          <TestiMonialsDoubleQuotes className="w-1/12 md:w-fit" />
        </span>
        <p className="text-lg md:text-base xl:text-lg font-light font-jost text-white text-justify px-6 md:px-12 md:mx-4">
          <span className="font-jost">
            Working with the team on our blockchain-based digital asset trading
            platform was an exceptional experience. Their expertise in merging
            advanced technology with user-centric design impressed us. The
            team&apos;s dedication to understanding our users&apos; needs and
            translating them into a seamless user experience resulted in a
            platform that met our objectives. The positive feedback we&apos;ve
            received from traders, along with the increased trading volume, is
            because of their exceptional work.
          </span>
        </p>
        <span className="flex justify-end pb-10">
          <TestiMonialsDoubleQuotes className="w-1/12 md:w-fit rotate-180" />
        </span>
        <div className="flex md:px-12 md:mx-4">
          <div className="pr-4 mr-2 fs-0">
            <Image
              alt="mchauhan"
              height={56}
              src={"/assets/case-study/mobifinx/m-chauhan.webp"}
              width={56}
            />
          </div>
          <div>
            <p className="text-lg font-jost text-white">
              <span className="font-semibold">M. Chauhan</span>
            </p>
            <p className="text-lg font-jost text-white">
              <span className="font-semibold">PO, India</span>
            </p>
          </div>
        </div>
      </div>
    </Container>
  </Container>
);

export default Testimonials;
